module.exports = __webpack_public_path__ + "img/index-banner2-m.267a1ad4.jpg";